export default "__VITE_PUBLIC_ASSET__6e48ee61__"